import { rootApi } from "../../api/rootApi";

export const redeemedDreamGiftsStatusApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    updateRedeemedDreamGiftsStatus: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/redeemedDreamGiftsStatus/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body:params.body,
        };
      },
    }),
    getAllDreamGiftsCheckout: builder.mutation({
        query: (params) => {
          return {
            method: "POST",
            url: `/tenant/redeemedDreamGiftsStatus/?limit=${params.limit}&offset=${params.offset}&zoneId=${params.zoneId}`,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
            body:params.body,
          };
        },
      }),
  }),
});

export const {
 useUpdateRedeemedDreamGiftsStatusMutation,
 useGetAllDreamGiftsCheckoutMutation
} = redeemedDreamGiftsStatusApi;
